import { render, staticRenderFns } from "./my-document-details.vue?vue&type=template&id=28b313a1&scoped=true&"
import script from "./js/my-document-details.js?vue&type=script&lang=js&"
export * from "./js/my-document-details.js?vue&type=script&lang=js&"
import style0 from "./my-document-details.vue?vue&type=style&index=0&id=28b313a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b313a1",
  null
  
)

export default component.exports